import React from "react";
import {
    Container,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Card,
    CardContent,
    ThemeProvider,
    createTheme,
    CssBaseline,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/T and cs policy.jpeg';


const theme = createTheme({
    palette: {
        primary: {
            main: "#10374A",
        },
        text: {
            primary: "#10374A",
            secondary: "#ffffff",
        },
    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
        h4: {
            fontWeight: 700,
            fontSize: "2rem",
            color: "#10374A",
        },
        body1: {
            fontSize: "1rem",
            lineHeight: 1.6,
        },
    },
});

const TermsOfUse = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Pageheader headertitle={"Terms Of Use"} bgImage={bgImage} />
            <Container maxWidth="md" sx={{ padding: "2rem 1rem" }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    WEBSITE TERMS OF USE
                </Typography>
                <Card sx={{ backgroundColor: "#F9FAFB", marginBottom: "1.5rem" }}>
                    <CardContent>
                        <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
                            <strong>By Using Our Site, You Accept These Terms and Conditions</strong>
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            Please read these Terms and Conditions carefully and ensure that you understand them before using Our Site. These Terms and Conditions, together with any other documents referred to herein, set out the terms of use governing your use of this website, www.royalespaces.in (“our site”). It is recommended that you print a copy of these Terms and Conditions for your future reference.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 2 }}>
                            Your agreement to comply with these Terms and Conditions is indicated by your use of Our Site. If you do not agree to these Terms and Conditions, you must stop using Our Site immediately.
                        </Typography>
                        <div style={{ marginTop: '1.5rem' }}>
                            <Typography variant="body1" color="text.primary" component="div">
                                The following documents also apply to your use of Our Site:
                            </Typography>
                            <ul style={{ color: '#10374A' }}>
                                <li>Our Privacy Policy</li>
                                <li>Our Cookie Policy</li>
                            </ul>
                        </div>
                    </CardContent>
                </Card>

                {/* Section 1 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Definitions and Interpretation</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary" gutterBottom>
                            In these Terms and Conditions, unless the context otherwise requires, the following expressions have the following meanings:
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>
                            <strong>“Content”</strong>: means any and all text, images, audio, video, property details, virtual tours, floorplans, graphics, measurements, scripts, code, software, databases, and any other form of information capable of being stored on a computer that appears on, or forms part of, Our Site; and
                        </Typography>
                        <Typography variant="body1" color="text.primary">
                            <strong>“We/Us/Our”</strong>: means Royale Spaces Limited.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 2 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Information About Us</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>2.1</strong> Our Site is operated by Royale Spaces Limited. We are a real estate agency registered in India. Our registered address and main trading address are in India.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>2.2</strong> GST number – Not registered at the time these Terms were drafted.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>2.3</strong> We are regulated in accordance with applicable Indian laws.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>2.4</strong> We address complaints as per applicable Indian laws and our grievance mechanism, Grievance Officer contact as per DPDP/IT rules.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 3 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How to Contact Us</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            To contact Us, please email us at info@royalespaces.com or telephone us on +91-7893092211.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 4 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Access to Our Site</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>4.1</strong> Access to Our Site is free of charge.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>4.2</strong> It is your responsibility to make the arrangements necessary in order to access Our Site.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>4.3</strong> Access to Our Site is provided on an “as is” and “as available” basis. We may suspend or discontinue Our Site (or any part of it) at any time. We do not guarantee that Our Site will always be available or that access to it will be uninterrupted. If We suspend or discontinue Our Site (or any part of it), We will try to give you reasonable notice where practicable.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 5 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Changes to Our Site</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            We may alter and update Our Site (or any part of it) at any time. If we make any significant alterations, we will try to give you reasonable notice.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 6 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Changes to These Terms and Conditions</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>6.1</strong> We may alter these Terms and Conditions at any time. Your continued use of Our Site constitutes your acceptance of any updated Terms and Conditions. You are advised to check this page regularly.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>6.2</strong> If any part of the current version of these Terms and Conditions conflicts with any previous version(s), the current version shall prevail unless explicitly stated otherwise.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 7 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">International Users</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Our Site is intended primarily for users in India. We do not warrant or represent that Our Site or its Content are available in other locations or suitable for use outside India.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 8 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How You May Use Our Site and Content (Intellectual Property Rights)</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>8.1</strong> All Content included on Our Site and the copyright and other intellectual property rights in that Content belong to or have been licensed by Us, unless specifically stated otherwise. All Content is protected under applicable Indian and international intellectual property laws.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>8.2</strong> You may access, view, and use Our Site in a web browser and may download Our Site (or any part of it) for caching purposes.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>8.3</strong> You may print one copy and download extracts of any page(s) from Our Site for personal reference use only.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>8.4</strong> You may not modify printed copies or downloaded extracts in any way. Images, video, audio, or other Content must not be used separately from accompanying text.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>8.5</strong> Our status as the owner and author of the Content on Our Site (or that of identified licensors) must always be acknowledged.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>8.6</strong> You may not use any Content from Our Site for commercial purposes without prior written permission from Us or our licensors.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 9 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Links to Our Site</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>9.1</strong> You may link only to the homepage of Our Site, www.royalespaces.in.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.2</strong> Linking to other pages requires Our express written permission.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.3</strong> Links must be fair and lawful and must not damage or take unfair advantage of Our reputation.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.4</strong> You must not suggest any association, endorsement, or approval where none exists.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.5</strong> You must not use Our logos or trademarks without Our express written permission.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.6</strong> You must not frame or embed Our Site on another website without Our express written permission.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>9.7</strong> You must not link to Our Site from any website We deem objectionable.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 10 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Links to Other Sites</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>10.1</strong> Our Site may contain links to third-party websites. Unless expressly stated, such sites are not under Our control. We accept no responsibility for the content of third-party websites.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>10.2</strong> The inclusion of a link does not imply any endorsement of the linked website or its operators.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 11 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Disclaimers</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>11.1</strong> Nothing on Our Site constitutes professional, financial, legal, or other advice. It is provided for general information purposes only. Professional advice should always be obtained before making decisions relating to any property.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>11.2</strong> We make reasonable efforts to ensure that the Content on Our Site is accurate and up to date, but We make no warranties or guarantees.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>11.3</strong> Property descriptions and information are not intended to be complete or exhaustive.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>11.4</strong> If you are a business user, We exclude all implied representations, warranties, conditions, and terms to the fullest extent permitted by law.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 12 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Our Liability</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>12.1</strong> Nothing in these Terms excludes or restricts Our liability for fraud, fraudulent misrepresentation, death, or personal injury caused by negligence, or any liability which cannot be excluded by law.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>12.2</strong> If you are a business user, to the fullest extent permitted by law, We accept no liability for any loss or damage arising out of or in connection with your use of Our Site or reliance on any Content.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>12.3</strong> If you are a business user, We are not liable for loss of profits, revenue, business opportunity, goodwill, or any indirect or consequential loss.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>12.4</strong> Our Site is intended for personal and informational use only. If you are a consumer, you agree not to use Our Site for business purposes, and We shall not be liable for any business losses.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>12.5</strong> If you are a consumer and digital content from Our Site damages your device due to Our failure to exercise reasonable care, We will repair or compensate as required by law.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 13 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Viruses, Malware, and Security</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>13.1</strong> We use reasonable security measures but do not guarantee that Our Site is free from viruses or malware.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>13.2</strong> You are responsible for protecting your devices and data.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>13.3</strong> You must not introduce viruses, malware, or harmful code.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>13.4</strong> You must not attempt unauthorised access to Our Site or related systems.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>13.5</strong> You must not carry out denial-of-service attacks or similar actions.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>13.6</strong> Any breach of this section may constitute a criminal offence under applicable Indian cyber laws. We will report such breaches and cooperate with law enforcement authorities.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 14 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Acceptable Use of Our Site</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>14.1</strong> You may only use Our Site lawfully and must comply with all applicable local, national, and international laws.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>14.2</strong> You must not use Our Site for unlawful, fraudulent, or harmful purposes or transmit malicious code.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>14.3</strong> If you breach this section, We may:
                        </Typography>
                        <ul style={{ color: '#10374A' }}>
                            <li>Suspend or terminate your access;</li>
                            <li>Issue a written warning;</li>
                            <li>Take legal action;</li>
                            <li>Disclose information to law enforcement authorities; and/or</li>
                            <li>Take any other lawful and appropriate action.</li>
                        </ul>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>14.4</strong> We exclude liability for actions taken in response to breaches of this section.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 15 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How We Use Your Personal Information</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            We will only use your personal information as set out in Our Privacy Policy and Our Cookie Policy.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Section 16 */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Law and Jurisdiction</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            <strong>16.1</strong> These Terms and Conditions and your relationship with Us shall be governed by and construed in accordance with the laws of India.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>16.2</strong> If you are a consumer, you will benefit from any mandatory provisions of the law in your country of residence.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>16.3</strong> Nothing in these Terms limits your legal rights as a consumer under applicable law.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>16.4</strong> If you are a business user, any disputes shall be subject to the exclusive jurisdiction of the courts of India.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Regulatory Compliance Notice */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Regulatory Compliance Notice</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            All offers of sale are subject to the rules and regulations governed by RERA and the Real Estate (Regulation and Development) Act, 2016.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                {/* Expression of Interest Disclaimer */}
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Expression of Interest Disclaimer</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Royale Spaces is only collecting your Expression of Interest. This does not create any obligation on either party to sell or purchase any property, apartment, villa, flat, or lease for which the information is being collected.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </ThemeProvider>
    );
};

export default TermsOfUse;
